$.validator.setDefaults({
    ignore: ":hidden:not('.force-validaion'), .ignore",
    highlight: function (element, _errorClass, _validClass) {
        var elm = $(element);
        elm.closest('.form-group,.form-group-custom.input-group,.input-group-custom').addClass('has-error');
    },
    unhighlight: function (element, _errorClass, _validClass) {
        var elm = $(element);
        elm.closest('.form-group,.form-group-custom.input-group,.input-group-custom').removeClass('has-error');
    }
});


// Register new custom method called filesize to check the file  size.
$.validator.addMethod("filesize", function (value, element, param) {

    if (value === "") {
        // no file supplied
        return true;
    }

    var maxKb = parseInt(param);

    if (element.files !== undefined && element.files[0] !== undefined && element.files[0].size !== undefined) {

        var filesizeInKb = parseInt(element.files[0].size) / 1000;

        return filesizeInKb <= maxKb;
    }

    // if the browser doesn't support the HTML5 file API, just return true
    // since returning false would prevent submitting the form 
    return true;
});

function getExtension(type) {

    var ext = '';
    if (type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        ext = 'docx';
    } else if (type === 'application/msword') {
        ext = 'doc';
    } else if (type === 'application/vnd.ms-excel') {
        ext = 'xls';
    } else if (type === 'application/vnd.ms-powerpoint') {
        ext = 'ppt';
    } else if (type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        ext = 'xlsx';
    } else {
        ext = type.split('/').pop();
    }

    return ext;
}


// Register custom method for file-extension validation
$.validator.addMethod("acceptedextensions", function (value, element, param) {

    if (value === "") {
        // no file supplied
        return true;
    }

    if (element.files !== undefined && element.files[0] !== undefined && element.files[0].name !== undefined) {
        var ext = getExtension(element.files[0].type);

        return $.inArray(ext, param) > -1;
    }

    // if the browser doesn't support the HTML5 file API, just return true
    // since returning false would prevent submitting the form 
    return true;
});


